var map = {
	"./buttons/add_coachee.svg": "./src/assets/images/buttons/add_coachee.svg",
	"./buttons/add_plus.svg": "./src/assets/images/buttons/add_plus.svg",
	"./buttons/attach.svg": "./src/assets/images/buttons/attach.svg",
	"./buttons/sync.svg": "./src/assets/images/buttons/sync.svg",
	"./buttons/upload.svg": "./src/assets/images/buttons/upload.svg",
	"./contents/icon-0.svg": "./src/assets/images/contents/icon-0.svg",
	"./contents/icon-0w.svg": "./src/assets/images/contents/icon-0w.svg",
	"./contents/icon-1.svg": "./src/assets/images/contents/icon-1.svg",
	"./contents/icon-1w.svg": "./src/assets/images/contents/icon-1w.svg",
	"./dash/1.svg": "./src/assets/images/dash/1.svg",
	"./dash/2.svg": "./src/assets/images/dash/2.svg",
	"./dash/3.svg": "./src/assets/images/dash/3.svg",
	"./dash/4.svg": "./src/assets/images/dash/4.svg",
	"./dash/5.svg": "./src/assets/images/dash/5.svg",
	"./dash/hand-shake.svg": "./src/assets/images/dash/hand-shake.svg",
	"./dashboard/1.svg": "./src/assets/images/dashboard/1.svg",
	"./dashboard/2.svg": "./src/assets/images/dashboard/2.svg",
	"./dashboard/3.svg": "./src/assets/images/dashboard/3.svg",
	"./dashboard/4.svg": "./src/assets/images/dashboard/4.svg",
	"./dashboard/5.svg": "./src/assets/images/dashboard/5.svg",
	"./dashboard/cloud_up.svg": "./src/assets/images/dashboard/cloud_up.svg",
	"./dashboard/i1.svg": "./src/assets/images/dashboard/i1.svg",
	"./dashboard/i2.svg": "./src/assets/images/dashboard/i2.svg",
	"./dashboard/i3.svg": "./src/assets/images/dashboard/i3.svg",
	"./dashp/1.svg": "./src/assets/images/dashp/1.svg",
	"./dashp/2.svg": "./src/assets/images/dashp/2.svg",
	"./dashp/3.svg": "./src/assets/images/dashp/3.svg",
	"./dashp/4.svg": "./src/assets/images/dashp/4.svg",
	"./dashp/5.svg": "./src/assets/images/dashp/5.svg",
	"./dashp/_4.svg": "./src/assets/images/dashp/_4.svg",
	"./dashp/hand-shake.svg": "./src/assets/images/dashp/hand-shake.svg",
	"./finances/icon-0.svg": "./src/assets/images/finances/icon-0.svg",
	"./finances/icon-0w.svg": "./src/assets/images/finances/icon-0w.svg",
	"./finances/icon-1.svg": "./src/assets/images/finances/icon-1.svg",
	"./finances/icon-1w.svg": "./src/assets/images/finances/icon-1w.svg",
	"./finances/icon-2.svg": "./src/assets/images/finances/icon-2.svg",
	"./finances/icon-2w.svg": "./src/assets/images/finances/icon-2w.svg",
	"./finances/icon-3.svg": "./src/assets/images/finances/icon-3.svg",
	"./finances/icon-3w.svg": "./src/assets/images/finances/icon-3w.svg",
	"./finances/sub-0.svg": "./src/assets/images/finances/sub-0.svg",
	"./finances/sub-0w.svg": "./src/assets/images/finances/sub-0w.svg",
	"./finances/sub-1.svg": "./src/assets/images/finances/sub-1.svg",
	"./finances/sub-1w.svg": "./src/assets/images/finances/sub-1w.svg",
	"./finances/sub-2.svg": "./src/assets/images/finances/sub-2.svg",
	"./finances/sub-2w.svg": "./src/assets/images/finances/sub-2w.svg",
	"./finances/sub2-0.svg": "./src/assets/images/finances/sub2-0.svg",
	"./finances/sub2-0w.svg": "./src/assets/images/finances/sub2-0w.svg",
	"./finances/sub2-1.svg": "./src/assets/images/finances/sub2-1.svg",
	"./finances/sub2-1w.svg": "./src/assets/images/finances/sub2-1w.svg",
	"./finances/sub2-2.svg": "./src/assets/images/finances/sub2-2.svg",
	"./finances/sub2-2w.svg": "./src/assets/images/finances/sub2-2w.svg",
	"./marketing/1.svg": "./src/assets/images/marketing/1.svg",
	"./marketing/2.svg": "./src/assets/images/marketing/2.svg",
	"./marketing/3.svg": "./src/assets/images/marketing/3.svg",
	"./marketing/4.svg": "./src/assets/images/marketing/4.svg",
	"./marketing/icon-0.svg": "./src/assets/images/marketing/icon-0.svg",
	"./marketing/icon-1.svg": "./src/assets/images/marketing/icon-1.svg",
	"./marketing/icon-2.svg": "./src/assets/images/marketing/icon-2.svg",
	"./marketing/icon-3.svg": "./src/assets/images/marketing/icon-3.svg",
	"./marketing/icon-4.svg": "./src/assets/images/marketing/icon-4.svg",
	"./marketing/sub-0.svg": "./src/assets/images/marketing/sub-0.svg",
	"./marketing/sub-0w.svg": "./src/assets/images/marketing/sub-0w.svg",
	"./marketing/sub-1.svg": "./src/assets/images/marketing/sub-1.svg",
	"./marketing/sub-1w.svg": "./src/assets/images/marketing/sub-1w.svg",
	"./menu/icon-0.svg": "./src/assets/images/menu/icon-0.svg",
	"./menu/icon-0w.svg": "./src/assets/images/menu/icon-0w.svg",
	"./menu/icon-1.svg": "./src/assets/images/menu/icon-1.svg",
	"./menu/icon-10.svg": "./src/assets/images/menu/icon-10.svg",
	"./menu/icon-10w.svg": "./src/assets/images/menu/icon-10w.svg",
	"./menu/icon-11.svg": "./src/assets/images/menu/icon-11.svg",
	"./menu/icon-11w.svg": "./src/assets/images/menu/icon-11w.svg",
	"./menu/icon-12.svg": "./src/assets/images/menu/icon-12.svg",
	"./menu/icon-12w.svg": "./src/assets/images/menu/icon-12w.svg",
	"./menu/icon-13.svg": "./src/assets/images/menu/icon-13.svg",
	"./menu/icon-13w.svg": "./src/assets/images/menu/icon-13w.svg",
	"./menu/icon-14.svg": "./src/assets/images/menu/icon-14.svg",
	"./menu/icon-14w.svg": "./src/assets/images/menu/icon-14w.svg",
	"./menu/icon-15.svg": "./src/assets/images/menu/icon-15.svg",
	"./menu/icon-15w.svg": "./src/assets/images/menu/icon-15w.svg",
	"./menu/icon-1w.svg": "./src/assets/images/menu/icon-1w.svg",
	"./menu/icon-2.svg": "./src/assets/images/menu/icon-2.svg",
	"./menu/icon-2w.svg": "./src/assets/images/menu/icon-2w.svg",
	"./menu/icon-3.svg": "./src/assets/images/menu/icon-3.svg",
	"./menu/icon-3w.svg": "./src/assets/images/menu/icon-3w.svg",
	"./menu/icon-4.svg": "./src/assets/images/menu/icon-4.svg",
	"./menu/icon-4w.svg": "./src/assets/images/menu/icon-4w.svg",
	"./menu/icon-5.svg": "./src/assets/images/menu/icon-5.svg",
	"./menu/icon-5w.svg": "./src/assets/images/menu/icon-5w.svg",
	"./menu/icon-6.svg": "./src/assets/images/menu/icon-6.svg",
	"./menu/icon-6w.svg": "./src/assets/images/menu/icon-6w.svg",
	"./menu/icon-7.svg": "./src/assets/images/menu/icon-7.svg",
	"./menu/icon-7w.svg": "./src/assets/images/menu/icon-7w.svg",
	"./menu/icon-8.svg": "./src/assets/images/menu/icon-8.svg",
	"./menu/icon-8w.svg": "./src/assets/images/menu/icon-8w.svg",
	"./menu/icon-9.svg": "./src/assets/images/menu/icon-9.svg",
	"./menu/icon-9w.svg": "./src/assets/images/menu/icon-9w.svg",
	"./menu/icon-analytics.svg": "./src/assets/images/menu/icon-analytics.svg",
	"./menu/icon-analyticsw.svg": "./src/assets/images/menu/icon-analyticsw.svg",
	"./menu/icon-dash.svg": "./src/assets/images/menu/icon-dash.svg",
	"./menu/icon-search.svg": "./src/assets/images/menu/icon-search.svg",
	"./menu/personal/icon-1.svg": "./src/assets/images/menu/personal/icon-1.svg",
	"./menu/personal/icon-1w.svg": "./src/assets/images/menu/personal/icon-1w.svg",
	"./menu/personal/icon-2.svg": "./src/assets/images/menu/personal/icon-2.svg",
	"./menu/personal/icon-2w.svg": "./src/assets/images/menu/personal/icon-2w.svg",
	"./menu/personal/icon-3.svg": "./src/assets/images/menu/personal/icon-3.svg",
	"./menu/personal/icon-3w.svg": "./src/assets/images/menu/personal/icon-3w.svg",
	"./menu/personal/icon-4.svg": "./src/assets/images/menu/personal/icon-4.svg",
	"./menu/personal/icon-4w.svg": "./src/assets/images/menu/personal/icon-4w.svg",
	"./menu/personal/icon-5.svg": "./src/assets/images/menu/personal/icon-5.svg",
	"./menu/personal/icon-5b.svg": "./src/assets/images/menu/personal/icon-5b.svg",
	"./menu/personal/icon-6.svg": "./src/assets/images/menu/personal/icon-6.svg",
	"./menu/personal/icon-6b.svg": "./src/assets/images/menu/personal/icon-6b.svg",
	"./menu/profile/Edificio.svg": "./src/assets/images/menu/profile/Edificio.svg",
	"./menu/profile/Estrelas.svg": "./src/assets/images/menu/profile/Estrelas.svg",
	"./menu/profile/Formacao.svg": "./src/assets/images/menu/profile/Formacao.svg",
	"./menu/profile/Maleta.svg": "./src/assets/images/menu/profile/Maleta.svg",
	"./menu/profile/Megafone.svg": "./src/assets/images/menu/profile/Megafone.svg",
	"./menu/profile/Pessoa.svg": "./src/assets/images/menu/profile/Pessoa.svg",
	"./menu/profile/icone_climby.svg": "./src/assets/images/menu/profile/icone_climby.svg",
	"./programs/icon-0.svg": "./src/assets/images/programs/icon-0.svg",
	"./programs/icon-0w.svg": "./src/assets/images/programs/icon-0w.svg",
	"./programs/icon-1.svg": "./src/assets/images/programs/icon-1.svg",
	"./programs/icon-1w.svg": "./src/assets/images/programs/icon-1w.svg",
	"./programs/icon-2.svg": "./src/assets/images/programs/icon-2.svg",
	"./programs/icon-2w.svg": "./src/assets/images/programs/icon-2w.svg",
	"./proposal/icon-0.svg": "./src/assets/images/proposal/icon-0.svg",
	"./proposal/icon-0w.svg": "./src/assets/images/proposal/icon-0w.svg",
	"./proposal/icon-1.svg": "./src/assets/images/proposal/icon-1.svg",
	"./proposal/icon-1w.svg": "./src/assets/images/proposal/icon-1w.svg",
	"./proposal/icon-2.svg": "./src/assets/images/proposal/icon-2.svg",
	"./proposal/icon-2w.svg": "./src/assets/images/proposal/icon-2w.svg",
	"./reports/dicon-0.svg": "./src/assets/images/reports/dicon-0.svg",
	"./reports/dicon-1.svg": "./src/assets/images/reports/dicon-1.svg",
	"./reports/dicon-2.svg": "./src/assets/images/reports/dicon-2.svg",
	"./reports/dicon-3.svg": "./src/assets/images/reports/dicon-3.svg",
	"./reports/icon-0.svg": "./src/assets/images/reports/icon-0.svg",
	"./reports/icon-0w.svg": "./src/assets/images/reports/icon-0w.svg",
	"./reports/micon-0.svg": "./src/assets/images/reports/micon-0.svg",
	"./reports/rel_analise_despesas.svg": "./src/assets/images/reports/rel_analise_despesas.svg",
	"./reports/rel_analise_recebimentos.svg": "./src/assets/images/reports/rel_analise_recebimentos.svg",
	"./reports/rel_fluxo_caixa.svg": "./src/assets/images/reports/rel_fluxo_caixa.svg",
	"./reports/rel_programas_coachee.svg": "./src/assets/images/reports/rel_programas_coachee.svg",
	"./reports/rel_propostas_emitidas.svg": "./src/assets/images/reports/rel_propostas_emitidas.svg",
	"./reports/rel_propostas_ganhas.svg": "./src/assets/images/reports/rel_propostas_ganhas.svg",
	"./reports/rel_relacao_coachee.svg": "./src/assets/images/reports/rel_relacao_coachee.svg",
	"./session/icon-0.svg": "./src/assets/images/session/icon-0.svg",
	"./session/icon-0w.svg": "./src/assets/images/session/icon-0w.svg",
	"./session/icon-1.svg": "./src/assets/images/session/icon-1.svg",
	"./session/icon-1w.svg": "./src/assets/images/session/icon-1w.svg",
	"./session/icon-2.svg": "./src/assets/images/session/icon-2.svg",
	"./session/icon-2w.svg": "./src/assets/images/session/icon-2w.svg",
	"./session/icon-3.svg": "./src/assets/images/session/icon-3.svg",
	"./session/icon-3w.svg": "./src/assets/images/session/icon-3w.svg",
	"./session/icon-4.svg": "./src/assets/images/session/icon-4.svg",
	"./session/icon-4w.svg": "./src/assets/images/session/icon-4w.svg",
	"./session/icon-5.svg": "./src/assets/images/session/icon-5.svg",
	"./session/icon-5w.svg": "./src/assets/images/session/icon-5w.svg",
	"./tables/add_coachee.svg": "./src/assets/images/tables/add_coachee.svg",
	"./tables/boleto.svg": "./src/assets/images/tables/boleto.svg",
	"./tables/doc_money.svg": "./src/assets/images/tables/doc_money.svg",
	"./tables/edit.svg": "./src/assets/images/tables/edit.svg",
	"./tables/edit_p.svg": "./src/assets/images/tables/edit_p.svg",
	"./tables/editor.svg": "./src/assets/images/tables/editor.svg",
	"./tables/eye.svg": "./src/assets/images/tables/eye.svg",
	"./tables/finance.svg": "./src/assets/images/tables/finance.svg",
	"./tables/follow.svg": "./src/assets/images/tables/follow.svg",
	"./tables/pef.svg": "./src/assets/images/tables/pef.svg",
	"./tables/printer.svg": "./src/assets/images/tables/printer.svg",
	"./tables/session.svg": "./src/assets/images/tables/session.svg",
	"./tables/share.svg": "./src/assets/images/tables/share.svg",
	"./tables/share_content.svg": "./src/assets/images/tables/share_content.svg",
	"./tables/share_line.svg": "./src/assets/images/tables/share_line.svg",
	"./tables/trash.svg": "./src/assets/images/tables/trash.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*\\/.*\\.svg$";